import AbstractNotifier from '@/utils/Services/Agent/Notifiers/AbstractNotifier';
import ApiNotifyPolicy from "@/policies/Proposal/Product/ProductPolicy/ApiNotifyPolicy";

export default class TravalcoNotifier extends AbstractNotifier {
    get title() {
        return 'Travalco notify';
    }

    get notificationTitle() {
        return 'Notificatie via Travalco API';
    }

    canCancelProduct() {
        return true;
    }

    proposalProductPolicy() {
        return ApiNotifyPolicy;
    }

    cancelProductConfirmMessage(agentProduct) {
        return super.cancelProductConfirmMessage(agentProduct) +
            "<br /><br /><strong>Let op:</strong> het product wordt geannuleerd in Travalco.";
    }

    hasProductBooking() {
        return true;
    }

    productBookingUrl(agentProduct) {
        return window.config.TRAVALCO_URL + '#/main/booking/' + agentProduct.travalco_booking_eid;
    }
}
